import ActionsCrudConstructor from '~/store/utils/ActionsCrudConstructor';
import createReducer from '~/store/utils/createReducer';
import { takeLatest, all } from 'redux-saga/effects';
import {
  findRecordRequest,
  destroyRecordRequest,
  updateRecordRequest,
  createRecordRequest,
  fetchListRecordsRequest,
} from '~/services/fetchApi/roles';
import {
  initLoading,
  setErrors,
  resetState,
  fetchStart,
  fetchDone,
  setCurrent,
  setChangeList,
  fetchListStart,
  fetchListDone
} from '~/store/utils/reducerFns';
import { rolesRoute } from '~/routes'

/* =================================================
  REDUX TYPES
================================================= */
export const ROLES_SET_CURRENT = '@App/roles/ROLES_SET_CURRENT';
export const ROLES_FETCH_START = '@App/roles/ROLES_FETCH_START';
export const ROLES_FETCH_DONE  = '@App/roles/ROLES_FETCH_DONE';
export const ROLES_FETCH_LIST_START = '@App/roles/ROLES_FETCH_LIST_START';
export const ROLES_FETCH_LIST_DONE = '@App/roles/ROLES_FETCH_LIST_DONE';
export const ROLES_SET_ERRORS = '@App/roles/ROLES_SET_ERRORS';
export const CLEAR_STATE = '@App/roles/CLEAR_STATE';
export const FIND_ROLE_REQUEST = '@App/roles/FIND_ROLE_REQUEST';
export const DESTROY_ROLES_REQUEST = '@App/roles/DESTROY_ROLES_REQUEST';
export const UPDATE_ROLES_REQUEST = '@App/roles/UPDATE_ROLES_REQUEST';
export const CREATE_ROLES_REQUEST = '@App/roles/CREATE_ROLES_REQUEST';
export const FETCH_ROLES_REQUEST  = '@App/roles/FETCH_ROLES_REQUEST';
export const ROLES_CHANGE_LIST  = '@App/roles/ROLES_CHANGE_LIST';

/* =================================================
  REDUX REDUCER
================================================= */

const INITIAL_STATE = {
  current:   undefined,
  data:      [],
  errors:    [],
  isLoading: false,
  listIsLoading: false,
  totalData: 0,
};

export default createReducer(
  INITIAL_STATE,
  {
    [CLEAR_STATE]: resetState,
    [ROLES_FETCH_START]: fetchStart,
    [ROLES_FETCH_DONE]:  fetchDone,
    [ROLES_FETCH_LIST_START]: fetchListStart,
    [ROLES_FETCH_LIST_DONE]: fetchListDone,
    [ROLES_SET_ERRORS]: setErrors,
    [ROLES_SET_CURRENT]: setCurrent,
    [DESTROY_ROLES_REQUEST]: initLoading,
    [CREATE_ROLES_REQUEST]: initLoading,
    [UPDATE_ROLES_REQUEST]: initLoading,
    [ROLES_CHANGE_LIST]: setChangeList,
  }
)

/* =================================================
  REDUX ACTIONS
================================================= */
export function clearState() { return { type: CLEAR_STATE } } // Utilizado ao desmontar os componentes
export function findRecord(id, params={}, callbackSuccess) {
  return {
    type: FIND_ROLE_REQUEST,
    payload: { id, params, callbackSuccess }
  }
}
export function destroyRecord(id, callbackSuccess) {
  return {
    type: DESTROY_ROLES_REQUEST,
    payload: { id, callbackSuccess }
  }
}

export function updateRecord(id, data, params={}, callbackSuccess=undefined, callbackFailed=undefined) {
  return {
    type: UPDATE_ROLES_REQUEST,
    payload: { id, data, params, callbackSuccess, callbackFailed }
  }
}
export function createRecord(data, params={}, callbackSuccess=undefined, callbackFailed=undefined) {
  return {
    type: CREATE_ROLES_REQUEST,
    payload: { data, params, callbackSuccess, callbackFailed }
  }
}

export function fetchRecords(params='', requestSource=undefined, callbackSuccess=undefined, callbackFailed=undefined) {
  return {
    type: FETCH_ROLES_REQUEST,
    payload: { params, requestSource, callbackSuccess, callbackFailed }
  }
}

export function setCurrentRecord(current) {
  return {
    type: ROLES_SET_CURRENT,
    payload: { current }
  }
}

/* =================================================
  SAGA ACTIONS
================================================= */
const crudActions = new ActionsCrudConstructor({
  reducerKey: 'roles',

  routes: {
    list: () => rolesRoute.list.build(),
    show: (id) => rolesRoute.show.build({id}),
    new: () => rolesRoute.new.build(),
  },

  apiRequests: {
    findRecordApi:    findRecordRequest,
    destroyRecordApi: destroyRecordRequest,
    updateRecordApi:  updateRecordRequest,
    createRecordApi:  createRecordRequest,
    fetchListApi:     fetchListRecordsRequest,
  },

  actionTypes: {
    FETCH_START:      ROLES_FETCH_START,
    FETCH_DONE:       ROLES_FETCH_DONE,
    FETCH_LIST_START: ROLES_FETCH_LIST_START,
    FETCH_LIST_DONE:  ROLES_FETCH_LIST_DONE,
    CHANGE_LIST:      ROLES_CHANGE_LIST,
    CHANGE_CURRENT:   ROLES_SET_CURRENT,
    SET_ERRORS:       ROLES_SET_ERRORS,
  }
});

export const saga = all([
  takeLatest(FIND_ROLE_REQUEST, crudActions.showAction),
  takeLatest(DESTROY_ROLES_REQUEST, crudActions.destroyAction),
  takeLatest(UPDATE_ROLES_REQUEST, crudActions.updateAction),
  takeLatest(CREATE_ROLES_REQUEST, crudActions.createAction),
  takeLatest(FETCH_ROLES_REQUEST, crudActions.fetchListAction),
]);